import {
  CLEAR_EDITS
  SET_COLUMNS
  SET_COLUMN_WIDTHS
  SET_CONTEXT_MENU_EVENT
  SET_COUNT
  SET_CURRENT_HIGHEST_REQUESTED
  SET_EDITS
  SET_FILTERS
  SET_IS_DRAGGING
  SET_IS_ESCAPING_EDIT_MODE
  SET_IS_FETCHING
  SET_IS_IN_EDIT_MODE
  SET_LOADING
  SET_NODE_ORDER
  SET_REDOS
  SET_RESIZED_COLUMN_WIDTHS
  SET_RELATIONS_MAP
  SET_ROW_HEADERS
  SET_ROWS_TO_BE_DELETED
  SET_SELECTION
  SET_SELECTION_TYPE
  SET_SORTER
  SET_UNDOS
} from './actionTypes'

export clearEdits = () ->
  type: CLEAR_EDITS

export performRedo = (currentEdits) ->
  type: SET_REDOS
  payload: { data: currentEdits }

export performUndo = (currentEdits) ->
  type: SET_UNDOS
  payload: { data: currentEdits }

export setColumns = (data) ->
  type: SET_COLUMNS
  payload: { data }

export setColWidths = (data) ->
  type: SET_COLUMN_WIDTHS
  payload: { data }

export setCount = (data) ->
  type: SET_COUNT
  payload: { data }

export setCtxMenuEvt = (data) ->
  type: SET_CONTEXT_MENU_EVENT
  payload: { data }

export setCurrentHighestRequested = (data) ->
  type: SET_CURRENT_HIGHEST_REQUESTED
  payload: { data }

export setEdits = ({ prevEdits, nextEdits }) ->
  type: SET_EDITS
  payload:
    data: { prevEdits, nextEdits }

export setFilters = (data) ->
  type: SET_FILTERS
  payload: { data }

export setIsDragging = (bool) ->
  type: SET_IS_DRAGGING
  payload:
    data: bool

export setIsEscapingEditMode = (bool) ->
  type: SET_IS_ESCAPING_EDIT_MODE
  payload:
    data: bool

export setIsFetching = (bool) ->
  type: SET_IS_FETCHING
  payload:
    data: bool

export setIsInEditMode = (bool) ->
  type: SET_IS_IN_EDIT_MODE
  payload:
    data: bool

export setLoading = (data) ->
  type: SET_LOADING
  payload: { data }

export setNodeOrder = (data) ->
  type: SET_NODE_ORDER
  payload: { data }

export setRelationsMap = (data) ->
  type: SET_RELATIONS_MAP
  payload: { data }

export setResizedColumnWidths = (data) ->
  type: SET_RESIZED_COLUMN_WIDTHS
  payload: { data }

export setRowsToBeDeleted = (data) ->
  type: SET_ROWS_TO_BE_DELETED
  payload: { data }

export setSelection = (data) ->
  type: SET_SELECTION
  payload: { data }

export setSelectionType = (type) ->
  type: SET_SELECTION_TYPE
  payload:
    data: type

export setSorter = (data) ->
  type: SET_SORTER
  payload: { data }
